import Button from "@components/ui/button";
import Icon from "@components/ui/icon";
import Spinner from "@components/ui/spinner";
import { useAppDispatch } from "@store";
import { closeDialog } from "@store/dialogs";
import { useValidatePurchase } from "../hooks";

const ID = "success-purchase-subscription";

const SuccessPurchaseSubscriptionDialog = ({ title }: { title: string }) => {
  const { error, success } = useValidatePurchase();
  const dispatch = useAppDispatch();
  return (
    <div className="tw-flex tw-h-[384px] tw-w-[624px] tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-bg-white">
      <img
        src="https://www.storydoc.com/assets/images/branding/favicon.png"
        alt="Storydoc icon"
        className="tw-mb-4 tw-size-10"
        width="40"
        height="40"
      />
      <p className="tw-mb-2 tw-mt-0 tw-text-center tw-font-sans tw-text-lg tw-font-bold tw-text-blue">
        Welcome to Storydoc {title}!
      </p>
      <p className="tw-mb-6 tw-mt-0 tw-text-center tw-font-sans tw-text-[13px]/normal tw-font-semibold tw-text-blue">
        Your invoice with payment confirmation will be sent to you shortly.
      </p>
      {!success && !error && (
        <div className="tw-flex tw-items-center tw-rounded tw-border tw-border-solid tw-border-blue-100 tw-bg-blue-50 tw-px-4 tw-py-2 tw-text-center tw-text-[11px]/normal tw-font-semibold">
          <Spinner className="tw-mr-2 tw-size-3" />
          Hold on tight, we are setting up your account
        </div>
      )}
      {success && (
        <div className="tw-flex tw-items-center">
          <div
            style={{
              background:
                "linear-gradient(0deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.6) 100%), #e6f6ed",
            }}
            className="tw-mr-4 tw-flex tw-h-8 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-solid tw-border-[#4CBA78]/30 tw-px-2 tw-text-[11px]/normal tw-font-semibold tw-text-blue"
          >
            <Icon
              icon="ri-checkbox-circle-fill"
              className="tw-mr-2 tw-text-green-500"
            />
            Everything is ready
          </div>
          <Button
            size="sm"
            variant="secondary"
            onClick={() => {
              window.location.href = "/pages/home";
            }}
          >
            Go to the platform
          </Button>
        </div>
      )}
      {error && (
        <div className="tw-flex tw-flex-col tw-items-center">
          <div className="tw-mb-4 tw-flex tw-h-8 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-solid tw-border-[#d43548]/30 tw-bg-[#ffeef0]/50 tw-px-2 tw-text-[11px]/normal tw-font-semibold tw-text-blue">
            <Icon
              icon="ri-error-warning-fill"
              className="tw-mr-2 tw-text-red-500"
            />
            Error occured setting up your account, we are on it and we will
            contact you shortly.
          </div>
          <Button
            size="sm"
            variant="secondary"
            onClick={() => dispatch(closeDialog(ID))}
          >
            Go to the platform
          </Button>
        </div>
      )}
    </div>
  );
};

export default SuccessPurchaseSubscriptionDialog;
